import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppConfig, APP_CONFIG } from '../../app.config';
import { HttpClient } from '@angular/common/http';

export type UpdatesModel = {
  unreadFaultNotificationsCount: number;
  newAuthorityInspectionErrandsCount: number;
  newRoundingErrandsCount: number; 
}

@Injectable()
export class UpdatesService {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/updates`;
  }

  private readonly _endpoint: string;

  getUpdates(): Observable<UpdatesModel> {
    return this._client.get<UpdatesModel>(this._endpoint);
  }
}
